/* eslint-disable array-callback-return */
import { PositionTrainingMatrixFilters } from '@/state/PositionTrainingMatrixFilter.atom';

import api from '../../services/apiSgft';
import { Filter } from '../../types/Filter';
import { TrainingTypeEnum } from '../trainingTypeOptions';

const fetchRegulatoryFilter = async (
	field: string,
	search: string,
	atom?: PositionTrainingMatrixFilters,
	positionType?: string,
) => {
	const response = await api.get(`${field}`, {
		params: {
			search,
			size: 1000000,
			page: 1,
			locations: atom?.location,
			positions: atom?.position,
			trainings: atom?.training,
			trainingType: [TrainingTypeEnum.REGULATORY],
			management: positionType === 'management' ? [] : atom?.management,
			areaCoordination: atom?.areaCoordination,
			getAll: false,
		},
	});

	if (field === 'trainings/locations') {
		return response.data
			.filter((it: { name: string }) => it.name !== 'Bacia do Espírito Santo')
			.map((it: { name: string }) => ({
				label:
					it.name === 'TAMAC'
						? 'Terminal Aquaviáro de Maceió (TAMAC)'
						: it.name,
				value: it.name,
			}));
	}
	if (positionType === 'management') {
		const uniqueValuesSet = new Set(
			response.data.map((it: { name: string }) => it.name),
		);
		return Array.from(uniqueValuesSet).map((management) => ({
			label: management,
			value: management,
		}));
	}
	if (positionType === 'areaCoordination') {
		const uniqueValuesSet = new Set(
			response.data.coordinations.map((it: { name: string }) => it.name),
		);
		return Array.from(uniqueValuesSet).map((areaCoordination) => ({
			label: areaCoordination,
			value: areaCoordination,
		}));
	}
	if (positionType === 'position') {
		const uniqueValuesSet = new Set(
			response.data.positions.map((it: { name: string }) => it.name),
		);
		return Array.from(uniqueValuesSet).map((position) => ({
			label: position,
			value: position,
		}));
	}
	return response.data
		.filter((it: { name: string }) => it.name !== 'TAMAC')
		.map((it: { name: string }) => {
			return {
				label: it.name,
				value: it.name,
			};
		});
};

export const regulatoryFilters: Filter[] = [
	{
		key: 'location',
		name: 'Matriz',
		options: [],
		isMulti: false,
		asyncFn: (search, atom?: PositionTrainingMatrixFilters) =>
			fetchRegulatoryFilter('trainings/locations', search, atom),
		isDisabled: () => false,
	},
	{
		key: 'management',
		name: 'Gerência',
		options: [],
		isMulti: true,
		asyncFn: (search, atom?: PositionTrainingMatrixFilters) =>
			fetchRegulatoryFilter(
				'new-management/filter',
				search,
				atom,
				'management',
			),
		isDisabled: (atom: PositionTrainingMatrixFilters) =>
			atom.location.length === 0,
	},
	{
		key: 'areaCoordination',
		name: 'Coordenação',
		options: [],
		isMulti: true,
		asyncFn: (search, atom?: PositionTrainingMatrixFilters) =>
			fetchRegulatoryFilter(
				'position/regulatory-training-link-filter',
				search,
				atom,
				'areaCoordination',
			),
		isDisabled: (atom: PositionTrainingMatrixFilters) =>
			atom.location.length === 0,
	},
	{
		key: 'position',
		name: 'Função',
		options: [],
		isMulti: true,
		asyncFn: (search, atom?: PositionTrainingMatrixFilters) =>
			fetchRegulatoryFilter(
				'position/regulatory-training-link-filter',
				search,
				atom,
				'position',
			),
		isDisabled: (atom: PositionTrainingMatrixFilters) =>
			atom.location.length === 0,
	},
	{
		key: 'training',
		name: 'Treinamento',
		options: [],
		isMulti: true,
		asyncFn: (search, atom?: PositionTrainingMatrixFilters) =>
			fetchRegulatoryFilter('trainings/filter', search, atom),
		isDisabled: (atom: PositionTrainingMatrixFilters) =>
			atom.location.length === 0,
	},
];
